<template>
  <v-container class="my-5">
    <v-dialog v-model="dialogInvitationDetail" scrollable max-width="600">
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Detalles de Invitación
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              class="align-self-end"
              color="red"
              icon
              @click="dialogInvitationDetail = false"
          ><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap v-if="selectedInvitation">
            <v-flex xs12>
              <p><strong>Residente:</strong> {{ selectedInvitation.resident_name }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Casa:</strong> {{ selectedInvitation.address }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Invitado:</strong> {{ selectedInvitation.guest_name }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Fecha:</strong> {{ selectedInvitation.date }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Tipo de Evento:</strong> {{ selectedInvitation.event_type }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Número de Asistentes:</strong> {{ selectedInvitation.attendees }}</p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Estado:</strong>
                <v-chip
                    :color="getStatusColor(selectedInvitation.status)"
                    text-color="white"
                    small
                >
                  {{ selectedInvitation.status }}
                </v-chip>
              </p>
            </v-flex>
            <v-flex xs12>
              <p><strong>Notas:</strong> {{ selectedInvitation.notes }}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialogInvitationDetail = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h2 class="subheading grey--text">Invitaciones del Club</h2>

    <v-card class="elevation-0 mt-4">
      <v-card-title>
        Lista de Invitaciones
      </v-card-title>
      <v-card-text>
        <v-layout row wrap class="mb-3">
          <v-flex xs12 sm6>
            <v-text-field
                v-model="filter"
                prepend-icon="mdi-magnify"
                label="Buscar invitación"
                clearable
                outlined
                dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
                v-model="statusFilter"
                :items="['Todas', 'Pendiente', 'Aprobada', 'Rechazada']"
                label="Filtrar por estado"
                outlined
                dense
            ></v-select>
          </v-flex>
        </v-layout>

        <v-data-table
            :headers="headers"
            :items="filteredData"
            :search="filter"
            class="elevation-1"
            no-data-text="No hay invitaciones registradas"
        >
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="getStatusColor(item.status)"
                text-color="white"
                small
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                color="primary"
                @click="openDetail(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ClubHouseInvitations',
  data () {
    return {
      dialogInvitationDetail: false,
      selectedInvitation: null,
      filter: '',
      statusFilter: 'Todas',
      headers: [
        { text: 'Residente', value: 'resident_name', sortable: true },
        { text: 'Invitado', value: 'guest_name', sortable: true },
        { text: 'Fecha', value: 'date', sortable: true },
        { text: 'Evento', value: 'event_type', sortable: false },
        { text: 'Estado', value: 'status', sortable: true },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      invitations: [
        {
          id: 1,
          resident_name: 'Carlos López',
          address: 'Calle Central 123',
          guest_name: 'María González',
          date: '2026-08-15',
          event_type: 'Cumpleaños',
          attendees: 25,
          status: 'Aprobada',
          notes: 'Evento familiar. Solicita catering.'
        },
        {
          id: 2,
          resident_name: 'Ana Rodríguez',
          address: 'Avenida Principal 456',
          guest_name: 'Juan Martínez',
          date: '2026-08-20',
          event_type: 'Boda',
          attendees: 120,
          status: 'Pendiente',
          notes: 'Gran evento social. Requiere permisos especiales.'
        },
        {
          id: 3,
          resident_name: 'Roberto García',
          address: 'Calle Secundaria 789',
          guest_name: 'Patricia Sánchez',
          date: '2026-08-10',
          event_type: 'Reunión Empresarial',
          attendees: 40,
          status: 'Aprobada',
          notes: 'Eventos corporativos permitidos.'
        },
        {
          id: 4,
          resident_name: 'Laura Fernández',
          address: 'Calle del Parque 321',
          guest_name: 'Diego Flores',
          date: '2026-08-05',
          event_type: 'Cena Social',
          attendees: 8,
          status: 'Rechazada',
          notes: 'Motivo: Conflicto de reserva con evento programado.'
        },
        {
          id: 5,
          resident_name: 'Miguel Torres',
          address: 'Avenida del Golf 654',
          guest_name: 'Fernando Ruiz',
          date: '2026-08-25',
          event_type: 'Torneo Privado',
          attendees: 60,
          status: 'Pendiente',
          notes: 'Requiere coordinación con gerencia de torneos.'
        }
      ]
    }
  },
  computed: {
    filteredData () {
      let filtered = this.invitations
      if (this.statusFilter !== 'Todas') {
        filtered = filtered.filter(inv => inv.status === this.statusFilter)
      }
      return filtered
    }
  },
  methods: {
    getStatusColor (status) {
      const colors = {
        'Aprobada': 'green',
        'Pendiente': 'orange',
        'Rechazada': 'red'
      }
      return colors[status] || 'gray'
    },
    openDetail (invitation) {
      this.selectedInvitation = invitation
      this.dialogInvitationDetail = true
    }
  }
}
</script>

<style scoped>
</style>
